import React from 'react';
import { FaEnvelope } from 'react-icons/fa';

const EmailButton = ({ email = "info@example.com", subject = "Inquiry", message = "Hello! I'd like to know more about your services." }) => {
  const handleClick = () => {
    const url = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    window.location.href = url;
  };

  return (
    <div className="email-button" onClick={handleClick}>
      <FaEnvelope />
    </div>
  );
};

export default EmailButton;

